import React, { useState, ReactNode } from "react";
import { bgcolor, Stack, styled } from "@mui/system";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Slide from "@mui/material/Slide";
import { FloatingButtonContainerProps, InnerButtonProps } from "./buttons.model";

// Styled component for the floating container
export const FloatingContainer = styled("div")({
  width: "fit-content",
  height: "fit-content",
  padding: "10px 20px",
  borderRadius: "4px",
  border: "none",
  background: "transparent",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "1rem",
  marginBottom: "2px", // Adjust as needed
});



export const InnerButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "lighten",
})<InnerButtonProps>(({ theme, lighten = false }) => ({
  textTransform: "none",
  width: "max-content",
  height: "28px", // Adjust as needed
  padding: "1rem",
  borderRadius: "30px",
  backgroundColor: "#F0CD7F",
  color: "#1C1C1C",
  fontWeight: "400",
  boxShadow:"none",
  "&.Mui-disabled": {
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    color: "rgba(0, 0, 0, 0.26)",
  },
  "&:hover": {
    backgroundColor: "#E0B86F", // Change background color on hover
    color: "#000000", // Change text color on hover
  }
}));

export const FloatingButtonContainer: React.FC<FloatingButtonContainerProps> = ({ children, isVisible }) => {
  return (
    <React.Fragment>
      {/* Grid container for centering */}
      {isVisible && (
        <Grid
          justifyContent="center"
          sx={{
            position: "fixed",
            bottom: "60px",
            width: "max-content",
            transform: "translateX(-50%)",
            left: '50%',
            zIndex: '2'
          }}
        >
          <Slide direction="up" in={isVisible}>
            <Grid item>
              <FloatingContainer>{children}</FloatingContainer>
            </Grid>
          </Slide>
        </Grid>
      )}
    </React.Fragment>
  );
};

// Example usage of the component with state management
const MyComponent: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  // Function to handle click event of the button to toggle visibility
  const handleToggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  return (
    <div>
      {/* Button to toggle visibility of the floating container */}
      <Button onClick={handleToggleVisibility} variant="contained">
        Toggle Floating Container
      </Button>

      {/* Usage of the FloatingButtonContainer */}
      <FloatingButtonContainer isVisible={isVisible}>
        <InnerButton variant="contained">done</InnerButton>
        <InnerButton variant="contained" color="info">
          Cancel
        </InnerButton>
      </FloatingButtonContainer>
    </div>
  );
};

export default MyComponent;
